"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation disableFee($feeId: String!) {
    disableFee(feeId: $feeId)
  }
`;
exports.default = mutation;
//# sourceMappingURL=deleteFee.mutation.js.map